// extracted by mini-css-extract-plugin
export default {"card":"UserCard_card__PbW3l"};